import React, { Component } from "react";

import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import AddIcon from '@material-ui/icons/Add';

import CurriculumFieldsRow from "./CurriculumFieldsRow.js";


class CurriculumFields extends Component {
	constructor(props) {
		super(props);
		
		this.handleChange = this.handleChange.bind(this);
		this.handleAdd = this.handleAdd.bind(this);
		this.handleRemove = this.handleRemove.bind(this);
	}

	handleChange(index, name, value) {
		let fields = this.props.fields;
		fields[index][name]=value;
		this.props.handleChange(this.props.fieldsName, fields);
		
	}
	handleRemove(index) {
		let fields = this.props.fields;
		fields.splice(index,1);
		this.props.handleChange(this.props.fieldsName, fields);
	}
	
	handleAdd(e) {
		e.preventDefault();
		let fields = this.props.fields;
		fields.push({"start": "", "finish": "", "institution": "", "subject": ""});
		this.props.handleChange(this.props.fieldsName, fields);
	}
	
	
	//{start, finish, institution, subject}
	render() {
		let rows = this.props.fields.map((element, index) => <CurriculumFieldsRow
															index = {index}
															start = {element.start}
															finish = {element.finish}
															institution = {element.institution}
															subject = {element.subject}
															handleChange = {this.handleChange}
															handleRemove = {this.handleRemove}
														/>);
		return(
			<div>
				<Table>
					<TableHead>
					<TableRow>
						<TableCell>Start</TableCell>
						<TableCell>Finish</TableCell>
						<TableCell>Institution</TableCell>
						<TableCell>Title/Project</TableCell>
						<TableCell>&nbsp;</TableCell>
					</TableRow>
					</TableHead>
					<TableBody>{rows}</TableBody>
				</Table>
				<Button variant="contained" color="primary" aria-label="Close" onClick={this.handleAdd}><AddIcon/></Button>
			</div>
		)
	}
}

export default CurriculumFields;


				